import * as actionTypes from 'ActionTypes';
import { updateObj } from 'Utils';

const initialState = {
	loading: false,
	error: null,
	// token: currentUser.getToken() || null,
	info: {}
};

export const UserReducer = (state = initialState, action) => {
	switch (action.type) {
		// case actionTypes.SET_TOKEN:
		// 	return updateObj(state, { token: action.token });
		case actionTypes.FETCH_USER_REQUEST:
			return updateObj(state, { loading: true });
		case actionTypes.FETCH_USER_FAIL:
			return updateObj(state, { error: action.error });
		case actionTypes.SET_USER:
			return updateObj(state, {
				loading: false,
				error: false,
				info: action.user
			});
		default:
			return state;
	}
};
